import axios from '@/http/axios/index.js'

export default {
    getVendor(id) {
        return axios.get('vendors-internal/' + id)
    },
    //catalogs
    getBanks() {
        return axios.get('vendors-internal/get-banks')
    },
    getClients() {
        return axios.get('vendors-internal/get-clients')
    },
    //Vendor
    updateVendor(id, data) {
        return axios.put('vendors-internal/' + id + '/update', data)
    },
    //Paydays
    getPaydays(id) {
        return axios.get('vendors-internal/' + id + '/paydays')
    },
    addPayday(data) {
        return axios.post('vendors-internal/payday/add', data)
    },
    updatePayday(id, data) {
        return axios.put('vendors-internal/payday/' + id + '/update', data)
    },
    deletePayday(id) {
        return axios.delete('vendors-internal/payday/' + id + '/delete')
    },
    //Accounts
    getAccounts(id) {
        return axios.get('vendors-internal/' + id + '/accounts')
    },
    addAccount(data) {
        return axios.post('vendors-internal/account/add', data)
    },
    updateAccount(id,data) {
        return axios.put('vendors-internal/account/' + id + '/update', data)
    },
    deleteAccount(id) {
        return axios.delete('vendors-internal/account/' + id + '/delete')
    },
     //Emails
    getEmails(id) {
        return axios.get('vendors-internal/' + id + '/emails')
    },
    addEmails(data) {
        return axios.post('vendors-internal/emails/add', data)
    },
    updateEmails(id,data) {
        return axios.put('vendors-internal/emails/' + id + '/update', data)
    },
    deleteEmails(id) {
        return axios.delete('vendors-internal/emails/' + id + '/delete')
    },

}
